import React from 'react';
import {Container}  from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const Footer = ({ currentYear }) => {
  return (
    <Container className='footer' fluid>
      <p>
        &copy; {currentYear} Cranburry Commons LLC | Website by Delvis Burgos Jr | 
        <Link to="/terms" className='footer-link'> Terms of Use</Link>
      </p>
    </Container>
  );
};

Footer.propTypes = {
  currentYear: PropTypes.number.isRequired,
};

Footer.defaultProps = {
  currentYear: new Date().getFullYear(),
};

export default Footer;
